import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ContextualInformation {
  contextualMessage: any;
  secondaryContextualMessage?: any;
  showLoading: boolean;
  showConfirmModal: boolean;
}

const initialState = {
  ContextualInformation: {
    contextualMessage: { message: '', type: '' },
    secondaryContextualMessage: { message: '', type: '' },
    showLoading: false,
    showConfirmModal: false,
  },
};

export const contextualSlice = createSlice({
  name: 'contextualSlice',
  initialState,
  reducers: {
    updateContextualMessage: (state, action) => {
      state.ContextualInformation.contextualMessage = action.payload;
    },
    updateSecondaryContextualMessage: (state, action) => {
      state.ContextualInformation.secondaryContextualMessage = action.payload;
    },
    updateShowLoading: (state, action) => {
      state.ContextualInformation.showLoading = action.payload;
    },
    updateShowConfirmModal: (state, action) => {
      state.ContextualInformation.showConfirmModal = action.payload;
    },
    resetContextualMessage: (state) => {
      state.ContextualInformation.contextualMessage =
        initialState.ContextualInformation.contextualMessage;
    },
  },
});

export const {
  updateContextualMessage,
  updateSecondaryContextualMessage,
  updateShowLoading,
  resetContextualMessage,
  updateShowConfirmModal,
} = contextualSlice.actions;

export const contextualInformation = (state: RootState) =>
  state.contextualSlice.ContextualInformation;
export const contextualInformationMessage = (state: RootState) =>
  state.contextualSlice.ContextualInformation.contextualMessage;
export const secondaryContextualInformationMessage = (state: RootState) =>
  state.contextualSlice.ContextualInformation.secondaryContextualMessage;
export const contextualInformationLoading = (state: RootState) =>
  state.contextualSlice.ContextualInformation.showLoading;
export const contextualInformationConfirmModal = (state: RootState) =>
  state.contextualSlice.ContextualInformation.showConfirmModal;

export default contextualSlice.reducer;
